import React from "react";
import { Helmet } from "react-helmet";

import Header from "./components/Header";
import Footer from "./components/Footer";

import "./css/style.css";

const Products = () => {
  return (
    <>
      <Helmet>
        <title>Grains - Krisula GlobExim</title>

        <meta charSet="UTF-8" />

        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        />

        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css"
        />
      </Helmet>

      {/* HEADER COMPONENT */}
      <Header />

      {/* HERO */}
      <section className="hero">
        <div className="overlay"></div>

        <div className="hero-content">
          <h1>Our Products</h1>

          <div className="breadcrumb">
            <span>Home</span>
            <span>/</span>
            <span>Products</span>
          </div>
        </div>
      </section>

      {/* PRODUCTS */}
      <section className="products-section">
        <div className="container">
          <h2 className="section-title">Grains</h2>

             <div class="product-block">
        <div class="text-content">
          <h3>Rice</h3>

          <p>
            We are well-established Rice Supplier & Exporter in India.
            Rice provided by us is obtained from the reputed vendors
            who process it using modern technique to keep its nutritional
            content intact. We pack the Rice in an appropriate manner
            so as to keep it safe from contamination.
          </p>

          <h4>Basmati Rice</h4>

          <p>
            Our Basmati Rice ranges are Traditional Basmati, Pusa Basmati,
            1121 Basmati & Sugandha Basmati. All these varieties are
            available in all forms - Brown, Milled Raw, Steamed,
            Par-boiled / Sella - White /Golden.
          </p>
        </div>

        <div class="image-content">
          <img
            src="https://images.unsplash.com/photo-1586201375761-83865001e31c?q=80&w=1200&auto=format&fit=crop"
            alt="Rice"
          />
        </div>
      </div>
      <div class="product-block">

        <div class="image-content">
          <img
            src="https://images.unsplash.com/photo-1516684732162-798a0062be99?q=80&w=1200&auto=format&fit=crop"
            alt="Non Basmati"
          />
        </div>

        <div class="text-content">
          <h4>Non-Basmati Rice</h4>

          <p>
            Our Non-Basmati Rice, In Long Grain ranges are PR11,
            IR 36, IR 64 & Parimal. In Short Grain, ranges are
            Ponni Rice, Sona Masoori, Swarna Masuri and Idly Rice.
          </p>
        </div>

      </div>

      <div class="product-block">

        <div class="text-content">
          <h3>Wheat (GRAIN/FLOUR)</h3>

          <p>
            We supply & export best quality of Wheat (Grain/Flour)
            from India. Wheat is one of the most nutritious grains
            which is extremely rich in anti-oxidants, minerals & vitamins.
          </p>

          <p>
            Packaging is done in pp bags (5/10/15/25/50 kg)
            as per our buyer’s requirements & shipped in
            20’GP dry container.
          </p>
        </div>

        <div class="image-content">
          <img
            src="https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?q=80&w=1200&auto=format&fit=crop"
            alt="Wheat"
          />
        </div>

      </div>

      <div class="product-block reverse">

        <div class="image-content">
          <img
            src="https://images.unsplash.com/photo-1509440159596-0249088772ff?q=80&w=1200&auto=format&fit=crop"
            alt="Millet"
          />
        </div>

        <div class="text-content">
          <h3>BAJARA (GREEN MILET) / YELLOW MAIZE</h3>

          <p>
            We Supply best quality of Bajara (Green Milet)
            & Yellow maize for human consumption and
            animal/cattle feed.
          </p>

          <p>
            Customized packaging available in PP Bags
            (25/50 Kg). We supply in bulk quantity with
            very competitive rates.
          </p>
        </div>

      </div>

        </div>
      </section>

      {/* FOOTER COMPONENT */}
      <Footer />
    </>
  );
};

export default Products;